export default function getCustomerDisplayName(customer) {
  if (customer && customer.firstName && customer.lastName) {
    const firstName = customer.firstName.charAt(0).toUpperCase() + customer.firstName.slice(1)
    const lastInitial = customer.lastName.charAt(0).toUpperCase()

    return firstName + ' ' + lastInitial + '.'
  } else return null
}
